module.exports = __webpack_public_path__ + "img/btn.4e6d2872.png";